function cov_1kz56wgcsg() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DoorFilled.tsx";
  var hash = "48fc34ebe0c454ad683166bad47304da8da2e99e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DoorFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "48fc34ebe0c454ad683166bad47304da8da2e99e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1kz56wgcsg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1kz56wgcsg();
var Icon = (cov_1kz56wgcsg().s[0]++, {
  name: 'door-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 2C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22H18C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H6ZM15.25 13.5C15.9404 13.5 16.5 12.9404 16.5 12.25C16.5 11.5596 15.9404 11 15.25 11C14.5596 11 14 11.5596 14 12.25C14 12.9404 14.5596 13.5 15.25 13.5Z\" fill=\"currentColor\"/>"
});
export default Icon;